import apiList from '@/configFiles/apiList.json';
import getBaseApi from './baseApi';

export default {
  loginApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.loginApi, data, config);
    return returnObject;
  },
  refreshTokenApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.refreshTokenApi, data, config);
    return returnObject;
  },
  registerApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.registerApi, data, config);
    return returnObject;
  },
  resetPwdApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.resetPwdApi, data, config);
    return returnObject;
  },
  forgotPwdApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.forgotPwdApi, data, config);
    return returnObject;
  },
  resetNewPwdApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.resetNewPwdApi, data, config);
    return returnObject;
  },
  wechatLoginApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.wechatLoginApi, data, config);
    return returnObject;
  },
  wechatBindLoginApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.wechatBindLoginApi, data, config);
    return returnObject;
  },
  wechatLinkToApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.wechatLinkToApi, data, config);
    return returnObject;
  },
  getUserNameApi() {
    const returnObject = getBaseApi.get(apiList.userNameApi);
    return returnObject;
  },
  getUserRightApi() {
    const returnObject = getBaseApi.get(apiList.userRightApi);
    return returnObject;
  },
  getMachineCodeApi() {
    const returnObject = getBaseApi.get(apiList.machineCodeApi);
    return returnObject;
  },
  getOrgCodeApi() {
    const returnObject = getBaseApi.get(apiList.userOrgCodeApi);
    return returnObject;
  },
  getLogoutApi() {
    const returnObject = getBaseApi.get(apiList.logoutApi);
    return returnObject;
  },
  getLatestNewsApi() {
    const returnObject = getBaseApi.get(apiList.latestNewsGetApi);
    return returnObject;
  },
  addLatestNewsApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.latestNewsGetApi, data, config);
    return returnObject;
  },
  deleteLatestNewsApi(url) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.delete(`${apiList.latestNewsGetApi}/${url}`, config);
    return returnObject;
  },
  editLatestNewsApi(url, data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.put(`${apiList.latestNewsGetApi}/${url}`, data, config);
    return returnObject;
  },
  decodeServoApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodeServoApi, data, config);
    return returnObject;
  },
  servoTwo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.servoTwo, data, config);
    return returnObject;
  },
  servoSeven(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.servoSeven, data, config);
    return returnObject;
  },
  decodeDateApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodeDateApi, data, config);
    return returnObject;
  },
  decodeHardwareApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodeHardwareApi, data, config);
    return returnObject;
  },
  decodePwdV1Api(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodePwdGenerateV1Api, data, config);
    return returnObject;
  },
  decodePwdV2Api(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodePwdGenerateV2Api, data, config);
    return returnObject;
  },
  decodePwdV2CleApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodePwdGenerateV2CleApi, data, config);
    return returnObject;
  },
  decodeCncPwdResetApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodeCncPwdResetApi, data, config);
    return returnObject;
  },
  decodeSnRestoreApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.decodeSnRestoreApi, data, config);
    return returnObject;
  },
  snInfoApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.snInfoApi, data, config);
    return returnObject;
  },
  snRegisterInfoApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.snRegisterInfoApi, data, config);
    return returnObject;
  },
  snFileDownloadList(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.snFileDownloadList, data, config);
    return returnObject;
  },
  snFileDownload(data) {
    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.snFileDownload, data, config);
    return returnObject;
  },
  cncWarHouseAnalysisApi() {
    const returnObject = getBaseApi.get(apiList.cncWarHouseAnalysis);
    return returnObject;
  },
  getRegistedCustomerName() {
    const returnObject = getBaseApi.get(apiList.getRegistedCustomerName);
    return returnObject;
  },
  deviceDataOverview(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.deviceDataOverview, data, config);
    return returnObject;
  },
  deviceDataRepairList(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.deviceDataRepairList, data, config);
    return returnObject;
  },
  getCompanyName() {
    const returnObject = getBaseApi.get(apiList.getCompanyName);
    return returnObject;
  },
  getUserAccount() {
    const returnObject = getBaseApi.get(apiList.getUserAccount);
    return returnObject;
  },
  productRegistration(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.productRegistration, data, config);
    return returnObject;
  },
  getAgreementApi() {
    const returnObject = getBaseApi.get(apiList.userAgreement);
    return returnObject;
  },
  submitAgreementApi(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.userAgreement, data, config);
    return returnObject;
  },
  editRegisterData(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.editRegisterData, data, config);
    return returnObject;
  },
  getPersonalInfo() {
    const returnObject = getBaseApi.get(apiList.personalInfo);
    return returnObject;
  },
  updatePersonalInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.put(apiList.personalInfo, data, config);
    return returnObject;
  },
  getMachineryDecodeRecord(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getMachineryDecodeRecord, data, config);
    return returnObject;
  },
  getRootDecodeRecord(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getRootDecodeRecord, data, config);
    return returnObject;
  },
  getRoleInfo() {
    const returnObject = getBaseApi.get(apiList.roleInfo);
    return returnObject;
  },
  getRightInfo() {
    const returnObject = getBaseApi.get(apiList.getRightInfo);
    return returnObject;
  },
  updateRoleInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.put(apiList.roleInfo, data, config);
    return returnObject;
  },
  addRoleInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.roleInfo, data, config);
    return returnObject;
  },
  getMachineryPlantAccount() {
    const returnObject = getBaseApi.get(apiList.machineryPlantAccount);
    return returnObject;
  },
  addMachineryPlantAccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.machineryPlantAccount, data, config);
    return returnObject;
  },
  deleteMachineryPlantAccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.deleteMachineryPlantAccount, data, config);
    return returnObject;
  },
  getMachineryPlantOptions() {
    const returnObject = getBaseApi.get(apiList.getMachineryPlantOptions);
    return returnObject;
  },
  updateMachineryPlantAccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.put(apiList.machineryPlantAccount, data, config);
    return returnObject;
  },
  getWechatNickname(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getWechatNickname, data, config);
    return returnObject;
  },
  updateWechatAssignSubaccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.wechatAssignSubaccount, data, config);
    return returnObject;
  },
  updatePersonalWechatAccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.personalWechatAssignAccount, data, config);
    return returnObject;
  },
  updatePersonalWechatBind(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.personalWechatBindAccount, data, config);
    return returnObject;
  },
  remailVerifyMail(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.remailVerifyCode, data, config);
    return returnObject;
  },
  getDueDatebySN(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getDueDatebySN, data, config);
    return returnObject;
  },
  getEmpInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.syntecUserEmpInfo, data, config);
    return returnObject;
  },
  getCompInfo() {
    const returnObject = getBaseApi.get(apiList.syntecUserCompInfo);
    return returnObject;
  },
  setRoleInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.syntecUserRoleInfo, data, config);
    return returnObject;
  },
  getMachineryAccountInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getMachineryAccount, data, config);
    return returnObject;
  },
  cancelMachineryVerify(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.cancelMachineryVerify, data, config);
    return returnObject;
  },
  machineryVerify(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const returnObject = getBaseApi.post(apiList.machineryVerify, data, config);
    return returnObject;
  },
  modifyMachineryAccount(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.editMachineryAccount, data, config);
    return returnObject;
  },
  modifyMachineryOption(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.editMachineryOption, data, config);
    return returnObject;
  },
  getOptionInfo() {
    const returnObject = getBaseApi.get(apiList.optionsList);
    return returnObject;
  },
  getQRcodeDataProcessing(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getQRcodeDataProcessing, data, config);
    return returnObject;
  },
  checkProductInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.checkProductSN, data, config);
    return returnObject;
  },
  getSubCompInfo() {
    const returnObject = getBaseApi.get(apiList.warrantyCompInfo);
    return returnObject;
  },
  getWarrantyProductInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.warrantyProductInfo, data, config);
    return returnObject;
  },
  getWarrantyMonthInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.warrantyMonthInfo, data, config);
    return returnObject;
  },
  purchaseWarranty(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.purchaseWarranty, data, config);
    return returnObject;
  },
  getQRcodeConnectionInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getQRcodeConnectionInfo, data, config);
    return returnObject;
  },
  getAppOptionList(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.appOptionList, data, config);
    return returnObject;
  },
  getSalesCompanyList(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.salesCompanyList, data, config);
    return returnObject;
  },
  getAppOptionRecord(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const returnObject = getBaseApi.post(apiList.appOptionRecord, data, config);
    return returnObject;
  },
  getAppOptionAuthKey(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    };
    const returnObject = getBaseApi.post(apiList.appOptionAuthKey, data, config);
    return returnObject;
  },
  getCncStatus(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getCncStatus, data, config);
    return returnObject;
  },
  getBackupRecord(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getBackupRecord, data, config);
    return returnObject;
  },
  singleLogDownload(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    };
    const returnObject = getBaseApi.post(apiList.singleLogDownload, data, config);
    return returnObject;
  },
  multipleLogDownload(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    };
    const returnObject = getBaseApi.post(apiList.multipleLogDownload, data, config);
    return returnObject;
  },
  triggerLogBackup(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.triggerLogBackup, data, config);
    return returnObject;
  },
  pollingLogBackup(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.pollingLogBackup, data, config);
    return returnObject;
  },
  downloadWarranty(data) {
    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.downloadWarranty, data, config);
    return returnObject;
  },

  // 小型专机试用-检验SN是否存在
  controller(data) {
    const returnObject = getBaseApi.get(`${apiList.controller}?SNumber=${data}`);
    return returnObject;
  },

  // 小型专机试用-查询选配项目
  searchMAOptions(data) {
    const returnObject = getBaseApi.get(`${apiList.searchMAOptions}?ExecID=${data}`);
    return returnObject;
  },

  // 小型专机试用-分公司名称获取
  branchOffice(data) {
    const returnObject = getBaseApi.get(`${apiList.branchOffice}?ExecID=${data}`);
    return returnObject;
  },

  setIndustrialMachineOptionTryCode(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.setIndustrialMachineOptionTryCode, data, config);
    return returnObject;
  },
  getReplacePassword(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getReplacePassword, data, config);
    return returnObject;
  },
  getCustomerIndustry(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.get(
      `/TTSM${apiList.getCustomerIndustry}?Language=${data.Language}&IndustryLevel1=${data.IndustryLevel1}&IndustryLevel2=${data.IndustryLevel2}`,
      data,
      config,
    );
    return returnObject;
  },
  GetCustomerIndustry(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.GetCustomerIndustry, data, config);
    return returnObject;
  },
  EndUserRegistration(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.EndUserRegistration, data, config);
    return returnObject;
  },
  searchMachineModel() {
    const returnObject = getBaseApi.get(apiList.searchMachineModel);
    return returnObject;
  },
  searchMachineBiz() {
    const returnObject = getBaseApi.get(apiList.searchMachineBiz);
    return returnObject;
  },
  getCustomerInfo() {
    const returnObject = getBaseApi.get(apiList.getCustomerInfo);
    return returnObject;
  },
  getOrgId() {
    const returnObject = getBaseApi.get(apiList.getOrgId);
    return returnObject;
  },
  searchProductDetailBySN(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.searchProductDetailBySN, data, config);
    return returnObject;
  },
  getLastMachineCode(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getLastMachineCode, data, config);
    return returnObject;
  },
  changeOptionCodeByBuyFunction(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const returnObject = getBaseApi.post(apiList.changeOptionCodeByBuyFunction, data, config);
    return returnObject;
  },
  getQRcodeData(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getQRcodeData, data, config);
    return returnObject;
  },
  resetOptionCodeByBuyFunction(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const returnObject = getBaseApi.post(apiList.resetOptionCodeByBuyFunction, data, config);
    return returnObject;
  },
  checkSpecialPwdGenerateV2V3Right() {
    const returnObject = getBaseApi.get(apiList.checkSpecialPwdGenerateV2V3Right);
    return returnObject;
  },
  changeOptionCodeByRefundFunction(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.changeOptionCodeByRefundFunction, data, config);
    return returnObject;
  },
  resetOptionCodeByRefundFunction(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.resetOptionCodeByRefundFunction, data, config);
    return returnObject;
  },
  searchOptionPriceOptionId(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.searchOptionPriceOptionId, data, config);
    return returnObject;
  },
  searchMachinePrice(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.searchMachinePrice, data, config);
    return returnObject;
  },
  searchOptionPrice(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.searchOptionPrice, data, config);
    return returnObject;
  },
  getOptionTrial(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.getOptionTrial, data, config);
    return returnObject;
  },
  searchMAOptions_business() {
    const returnObject = getBaseApi.get(apiList.searchMAOptions_business);
    return returnObject;
  },
  limitPwHardware(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.limitPwHardware, data, config);
    return returnObject;
  },
  writeSNGeneratePwd(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.writeSNGeneratePwd, data, config);
    return returnObject;
  },
  generateQRCode(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.generateQRCode, data, config);
    return returnObject;
  },
  limitPwMon(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.limitPwMon, data, config);
    return returnObject;
  },
  limitPwDay(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.limitPwDay, data, config);
    return returnObject;
  },
  limitPwUnlimit(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi.post(apiList.limitPwUnlimit, data, config);
    return returnObject;
  },
  setIndustrialMachineOptionCode(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.setIndustrialMachineOptionCode, data, config);
    return returnObject;
  },
  checkSNExist(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.checkSNExist, data, config);
    return returnObject;
  },
  getWarrantyType() {
    const returnObject = getBaseApi.get(apiList.getWarrantyType);
    return returnObject;
  },
  getSNInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.getSNInfo, data, config);
    return returnObject;
  },
  renewSNWarrantyDate(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.renewSNWarrantyDate, data, config);
    return returnObject;
  },
  searchSNInfo(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.searchSNInfo, data, config);
    return returnObject;
  },
  changeforChangeMachineType(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.changeforChangeMachineType, data, config);
    return returnObject;
  },
  optionsInsert(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.optionsInsert, data, config);
    return returnObject;
  },
  optionsUpdate(data) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const returnObject = getBaseApi
      .post(apiList.optionsUpdate, data, config);
    return returnObject;
  },
};
